import { render, staticRenderFns } from "./PerformanceProductList.vue?vue&type=template&id=d2058da4&scoped=true&"
import script from "./PerformanceProductList.vue?vue&type=script&lang=js&"
export * from "./PerformanceProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2058da4",
  null
  
)

export default component.exports